import { Injectable } from '@angular/core';
import { UrlService } from '@ddt-web/url';

import { TealiumAnalyticsAdapter } from '../adapters';
import { PortfolioAnalyserAnalyticsConfig } from '../configs/portfolio-analyser-analytics.config';
import { IAnalyticsConfig, IEventConfig } from '../models/analytics.config.interface';
import { AnalyticsHelperUtil } from '../utils/analytics-helper.util';
import { GlobalAnalyticsMapperUtil } from '../utils/global-analytics-mapper.util';

@Injectable()
export class AnalyticsManager {
	private isNewAnalysis: boolean = false;
	private pageName: string;
	private isOutboundSrc: boolean = false;
	private analyticsConfig: Array<IAnalyticsConfig> = PortfolioAnalyserAnalyticsConfig;

	constructor(private tealiumAnalyticsAdapter: TealiumAnalyticsAdapter, private urlService: UrlService) { }

	public init(): void {
		if (!window['globalAnalyticsParams']) {
			window['globalAnalyticsParams'] = {};
		}
		GlobalAnalyticsMapperUtil.setToolName();
		GlobalAnalyticsMapperUtil.setMode();
		GlobalAnalyticsMapperUtil.setTrackingVariable();
		document.addEventListener('click', event => this.onClickEventHandler(event));
		this.urlService.initLocationChangeEventHandler(event => this.onLocationChangeEventHandler(event));
	}

	private onClickEventHandler(event): void {
		let id = event && event.target && event.target.getAttribute('custom-event-type');
		if (!id && event.target.localName === 'svg') {
			const ele = event.target.parentElement as HTMLElement;
			id = ele.getAttribute('custom-event-type');
		}
		this.processEvent(id);
	}

	private onLocationChangeEventHandler(event): void {
		if (event) {
			this.pageName = AnalyticsHelperUtil.getPageName(event.url);
			this.isOutboundSrc = event.id === 1;
			this.processEvent(this.pageName.toLowerCase());
		}
	}

	private processEvent(id): void {
		const analyticsConfigItems = this.analyticsConfig.filter(item => item.id === id);
		if (analyticsConfigItems && analyticsConfigItems.length) {
			analyticsConfigItems.forEach(analyticsConfigItem => {
				let shouldFireEvent = true;

				// step 1) apply any business rules to this analytic event
				analyticsConfigItem.rules.forEach(rule => {
					if (!this.applyAnalyticsRules(rule)) {
						shouldFireEvent = false;
					}
				});

				if (shouldFireEvent) {
					analyticsConfigItem.events.forEach((eventConfig: IEventConfig) => {
						// step 2) build the analytic event
						eventConfig.pageName = this.pageName;
						const event = this.tealiumAnalyticsAdapter.buildAnalyticsEvent(eventConfig, this.isNewAnalysis);
						this.tealiumAnalyticsAdapter.sendAnalyticsEvent(event);
					});
				}
			});
		}
	}

	private applyAnalyticsRules(rule: string): boolean {
		switch (rule) {
			case 'deepLinkRule':
				return this.isOutboundSrc;
			case 'startEventRule':
				this.isNewAnalysis = window.location.href.indexOf('new-analysis') > -1;
				return true;
			default:
				return true;
		}
	}
}
